export const SET_DETECT = (state, payload) => {
  state.detects = payload;
}
export const SET_AUTO_DETECT = (state, payload) => {
  state.auto_detects = payload;
}
